module.exports = __webpack_public_path__ + "a43d207bb960dd929ee7c414f75f8053.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-21.png
// module id = 1465
// module chunks = 0